export const AddressGuestComponent = {
    template: `
        <oo-card>
            <oo-card-header>
                <p>Delivery Address</p>
            </oo-card-header>

            <oo-card-body>
                <add-address
                    address="$ctrl.addressService.data"
                    on-address-selection="$ctrl.onAddressSelection(address)"
                    save="disabled"
                >
                </add-address>
                <ng-form name="$ctrl.addressValidation">
                    <address-suggestions
                        ng-if="$ctrl.addressService.errors.errorMessage"
                        current-address="$ctrl.addressService.data"
                        error="$ctrl.addressService.errors"
                        on-address-selection="$ctrl._setAddressFromSuggestion(address)"></address-suggestions>
                </ng-form>
            </oo-card-body>
        </oo-card>
    `,
    controller: class {
        constructor(addressService, orderInfoService, $rootScope) {
            'ngInject';
            this.addressService = addressService;
            this.orderInfoService = orderInfoService;
            this.$rootScope = $rootScope;
            this.outOfDeliveryArea = false;
        }

        onAddressSelection(address) {
            this.addressValidation.$setValidity('delivery-range', true);

            if (!this.addressService.isComplete(address)) {
                return;
            }

            this.addressService.validateWithDeliveryRange()
                .then(
                    () => {
                        this.outOfDeliveryArea = false;
                        this.addressService.updateDeliveryFee();
                    },
                    () => {
                        this.addressValidation.$setValidity('delivery-range', false);
                        this.outOfDeliveryArea = true;
                    }
                );
        }

        _setAddressFromSuggestion(address) {
            this.addressService.setAddress(address);
            this.$rootScope.$broadcast('angucomplete-alt:changeInput', 'geo-input-suggest', address);
        }

        $onInit() {
            this.addressService.setAddress(this.orderInfoService.getDeliveryInfo());

        }
    }
};
